export default __webpack_public_path__ + "static/media/icon-check-reg-type.bcf20aa7.svg";